import { autocompleteEndpoint } from 'endpoints';
import { singleRequestServiceFactory } from '../rest/request/singleRequestServiceFactory';

export const autocompleteRest = {
    autocomplete: singleRequestServiceFactory(autocompleteEndpoint)
};



// WEBPACK FOOTER //
// ./services/rest/autocomplete.js